import { useUserStore } from 'store/user.store';
import analytics from 'utilitys/helpers/Analytics/analytics';
import { useQueryClient } from 'react-query';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Userpilot } from 'userpilot';
import { token as tokenStorage } from 'services/LocalStorage/localStorage';
import { useMobileStore } from 'store/mobile.store';

export const Logout = () => {
    const queryClient = useQueryClient();
    const history = useHistory();
    const logout = useUserStore((state) => state.logout);
    const updateMobile = useMobileStore((state) => state.update);

    useEffect(() => {
        tokenStorage.clear();
        analytics.mixpanelReset();
        queryClient.clear();
        updateMobile({ isMobile: false });
        logout();
        try {
            Userpilot.clean();
            Userpilot.destroy();
        } catch (e) {
            console.log(e);
            console.log('error userpilot');
        }
        history.push('/');
        window.location.reload();
    }, []);

    return null;
};
